<template>
  <transition name="fade">
    <div class="launch-confirmation-wrapper">
      <div class="launch-confirmation-overlay" :class="{ show: isOpen }" @click="$emit('close')" />
      <transition name="fade">
        <div v-if="isOpen" class="launch-confirmation">
          <div class="launch-confirmation-container">
            <div class="warn-block">
              <h2>{{ $t("game.launchConfirmation.title") }}</h2>
              <p class="text" v-safe-html="$t('game.launchConfirmation.text')"></p>
            </div>
            <div class="warn-block inline">
              <Button class="outline light" :label="$t('game.preGameModalChecksWithTips.backButton')" @click="$emit('close')" />
              <Button class="primary" :label="$t('other.actions.continue')" :loading="state.isLoading" @click="startSession()" />
            </div>
          </div>
        </div>
      </transition>
    </div>
  </transition>
</template>

<style lang="scss" scoped>
@import "@/assets/style/variables.scss";

.launch-confirmation-wrapper .launch-confirmation {
  max-width: 1460px;

  padding: 80px 2px 80px 80px;

  border-radius: 12px;
  border: 2px solid #464646;
  background: #1d1d1d;

  @media screen and (max-width: $small-screen) {
    @media (orientation: "landscape") {
      padding: 20px 2px 20px 20px;

      &::before {
        display: none;
      }
    }
  }

  .text {
    font-size: 18px;

    @media screen and (max-width: $small-screen) {
      font-size: 14px;
    }
  }

  ::v-deep(b) {
    font-weight: 700;
    color: #f2cb36;
  }

  @media screen and (max-width: $portrait-small-screen) {
    padding: 40px;
  
    .text {
      font-size: 14px;
    }

    &::before {
      display: none;
    }

    .launch-confirmation-container {
      width: 100%;
    }
  }

  @media screen and (min-width: $small-screen) and (max-width: $medium-screen) {
    max-height: 95%;
    padding: 15px 2px 15px 15px;
    &::before {
      width: 25%;
    }

    .text {
      font-size: 14px;
    }

    .launch-confirmation-container {
      width: 70%;
    }
  }

}
</style>

<script setup>
import { watch, reactive } from "vue";
import { useRouter } from "vue-router";
import { useCloudClientStore } from "@/stores/cloud-client";
import { useToast } from "vue-toastification";

const router = useRouter();
const { t } = useI18n();
const toast = useToast();
const cloudClient = useCloudClientStore();
const route = useRoute();

defineEmits(["close"]);

const state = reactive({
  isMounted: false,
  isLoading: false,
});

const props = defineProps({
  isOpen: {
    type: Boolean,
    required: true,
  },
});

watch(props, () => {
  if (props.isOpen) {
    setTimeout(() => {
      state.isMounted = true;
    }, 300);
  }
});

async function startSession() {
  if (state.isLoading) return;
  state.isLoading = true;
  if (await cloudClient.startSession()) {
    state.isLoading = false;
    router.push({ name: "game-waiting", query: route.query });
  } else {
    toast.error(`${t("game.preGameModalChecksNoHost.title")}\n${t("game.preGameModalChecksNoHost.text")}`);
    state.isLoading = false;
  }
}
</script>
